import { Company } from "../model/company";

export interface LoginData {
    username: string
    password: string
}

export interface UserSession {
    token: string
    user: User
    expiresAt: Date
}

export interface User {
    id: string
    username: string
    email: string
    phoneNumber: string
    lang: string
    role: string
}

export enum Roles {
    SuperAdmin = 'super_admin',
    CompanyAdmin = 'company_admin',
	ServicemanRole   = "serviceman",
    User = 'user'
}

export class UsersRepository {

    constructor() { }

    async list(): Promise<Company[]> {
        return fetch('/api/schema/companies').then((response) => {
            return response.json()
        });
    }

    async login(data: LoginData): Promise<UserSession> {
        return fetch(`/api/schema/users/login`, {
            method: 'POST',
            body: JSON.stringify(data),
            headers: new Headers({
                'Content-Type': 'application/json'
            })
        }).then((response) => {
            return response.json()
        });
    }

    roles(): string[] {
        return ['user', 'company_admin', 'super_admin', 'serviceman']
    }
}